import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

let initialized = false;

export function initPostHog() {
    if (initialized || !POSTHOG_KEY) {
        if (!POSTHOG_KEY) {
            console.warn('PostHog: REACT_APP_POSTHOG_KEY not set, analytics disabled');
        }
        return;
    }

    posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        autocapture: true,
        capture_pageview: true,
        capture_pageleave: true,
        session_recording: {
            recordCrossOriginIframes: false,
        },
        persistence: 'localStorage',
        loaded: (ph) => {
            // Disable in development unless explicitly enabled
            if (process.env.NODE_ENV === 'development' && !process.env.REACT_APP_POSTHOG_DEV) {
                ph.opt_out_capturing();
            }
        }
    });

    initialized = true;
}

export function identifyUser(user) {
    if (!POSTHOG_KEY || !user) return;

    posthog.identify(user.user_id, {
        email: user.email,
        username: user.username,
        role: user.role,
    });
}

export function resetUser() {
    if (!POSTHOG_KEY) return;
    posthog.reset();
}

export function trackEvent(event, properties = {}) {
    if (!POSTHOG_KEY) return;
    posthog.capture(event, properties);
}

export { posthog };
